import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'kb-stock-level-label',
    templateUrl: './stock-level-label.component.html',
    styleUrls: ['./stock-level-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, NgClass],
})
export class StockLevelLabelComponent {
    @Input()
    stockLevel: string;

    get stockLevelLabel(): string {
        switch (this.stockLevel) {
            case 'IN_STOCK':
                return 'In stock';
            case 'LOW_STOCK':
                return 'Low stock';
            case 'OUT_OF_STOCK':
                return 'Out of stock';
        }
        return this.stockLevel ?? '';
    }
}
